import sprintf from 'sprintf';
import SMConst from 'lib/SMConst';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMAppHelper {

  static isServerRendering(){
    return typeof window === 'undefined';
  }

  static setTitle(title){
    document.title = sprintf("%s|%s", title, I18n.t("dashboard.label_000001"));
  }

  static userIsCorp(reservation){
    return (reservation.use_type == SMConst.ReservationUseType.Corporate &&
        reservation.user.corp_name);
  }

  static userIsDeleted(user){
    return user.deleted_at;
  }

  static ownerIsDeleted(owner){
    if (!owner) {
      return false;
    } else {
      return owner.deleted_at;
    }
  }

  static maxMobileWidth(){
    return 768;
  }
  
  static maxTabletWidth(){
    return 991;
  }

  static windowWidth(){
    if (!SMAppHelper.isServerRendering()) {
      return window.innerWidth;
    }
    return null;
  }

  static isMobile(){
    const width = SMAppHelper.windowWidth();
    if (width == null) return null;
    return (width <= this.maxMobileWidth());
  }

  static isTablet(){
    const width = SMAppHelper.windowWidth();
    if (width == null) return null;
    return (width <= this.maxTabletWidth());
  }
  
  static isMobileMainCol(){
    return $("body").hasClass("sp-maincol");
  }

  static isMobileSideCol(){
    return $("body").hasClass("sp-sidecol");
  }

  static observeScrollToBottom(target, callback){
    const $target = $(target);
    const y = $target.scrollTop() + $target.outerHeight();

    if (target == window) {
      if ($(document).height() <= y) callback();
    } else {
      if (target.scrollHeight <= y) callback();
    }
  }

  static redirectTo(url){
    window.location = url;
  }

  static redirectToLogin(){
    SMAppHelper.redirectTo(Routes.new_user_session_path());
  }

  static getBrowser(){
    const ua = window.navigator.userAgent.toLowerCase();
    const ver = window.navigator.appVersion.toLowerCase();
    let name = 'unknown';
    let version = 0;

    if (ua.indexOf("msie") != -1){
      if (ver.indexOf("msie 6.") != -1){
        name = 'ie';
        version = 6;
      }
      else if (ver.indexOf("msie 7.") != -1){
        name = 'ie';
        version = 7;
      }
      else if (ver.indexOf("msie 8.") != -1){
        name = 'ie';
        version = 8;
      }
      else if (ver.indexOf("msie 9.") != -1){
        name = 'ie';
        version = 9;
      }
      else if (ver.indexOf("msie 10.") != -1){
        name = 'ie';
        version = 10;
      }
    }
    else if(ua.indexOf('trident') != -1){
      name = 'ie';
      version = 11;
    }
    else if (ua.indexOf('chrome') != -1){
      name = 'chrome';
    }
    else if (ua.indexOf('safari') != -1){
      name = 'safari';
    }
    else if (ua.indexOf('opera') != -1){
      name = 'opera';
    }
    else if (ua.indexOf('firefox') != -1){
      name = 'firefox';
    }
    return [name, version];
  }

  // 対応ブラウザかどうか判定
  // @param  対応ブラウザ名を配列で渡す(ie6、ie7、ie8、ie9、ie10、ie11、chrome、safari、opera、firefox)
  // @return サポートしてるかどうかをtrue/falseで返す
  static isSupportBrowser(){
    const theBrowser = SMAppHelper.getBrowser();
    const browsers = ['chrome','safari','opera','firefox','ie'];
    let ret = false;
    for(var i=0; i<browsers.length; i++){
      if(browsers[i] == theBrowser[0]){
        if(browsers[i] == 'ie'){
          if(theBrowser[1] < 10) {
            break;
          }
        }
        ret = true;
        break;
      }
    }
    return ret;
  }

  static validateBrowser(){
    if(!SMAppHelper.isSupportBrowser()) {
      $('#js-support-browser-message').show();
    }
  }

  static canBodyScroll(enable){
    const className = "js-scroll__disable";
    const $body = $("body");
    if (enable) {
      let top = $body.css("top");
      $body.removeClass(className).css({top: "auto"});
      $body.scrollTop(0 - parseInt(top));
    } else {
      let top = $body.scrollTop();
      $body.addClass(className).css({top: 0 - top});
    }
  }

  static policyUrl(room){
    return room.space.policy ? Routes.cancel_policy_space_room_path(room.space.username, room.uid) : Routes.cancel_policy_about_index_path();
  }

  static termsUrl(room){
    return room.space.terms ? Routes.terms_space_room_path(room.space.username, room.uid) : Routes.terms_of_space_use_about_index_path();
  }

  static helpUrl(articleId){
    return "https://help.spacemarket.com/hc/ja/articles/" + articleId;
  }

  static shareRoomMailUrl(room){
    const url = "https://" + location.host + Routes.space_room_path(room.space.username, room.uid, {
      utm_campaign: campaign,
      utm_source: "email",
      utm_medium: "share",
    });
    const campaign = "room-" + room.uid;
    const roomName = SMFormatHelper.roomName(room);
    const br = "%0d%0a";
    const subject = "【スペースのシェア】" + roomName;
    const body = sprintf("%s%s%s", roomName, br, encodeURIComponent(url));
    return sprintf("mailto:?subject=%s&body=%s", subject,body);
  }

  static shareRoomFacebookMessageUrl(room){
    const prefix = location.pathname.length && location.pathname[0] == "?" ? "&" : "?";
    const campaign = "room-" + room.uid;
    const url = "https://" +location.host + Routes.space_room_path(room.space.username, room.uid) + sprintf("%sutm_campaign=%s&utm_source=%s&utm_medium=%s",
      prefix, campaign, "facebook", "message"
    );
    const redirect = encodeURIComponent("https://spacemarket.com/");
    return sprintf("http://www.facebook.com/dialog/send?app_id=%s&link=%s&redirect_uri=%s",
      SpaceMarket.Config.FBAppID, encodeURIComponent(url), redirect
    );
  }

  static shareRoomFacebookShareUrl(room){
    const prefix = location.pathname.length && location.pathname[0] == "?" ? "&" : "?";
    const campaign = "room-" + room.uid;
    const url = "https://" + location.host + Routes.space_room_path(room.space.username, room.uid) + sprintf("%sutm_campaign=%s&utm_source=%s&utm_medium=%s",
      prefix, campaign, "facebook", "share"
    );
    return sprintf('http://www.facebook.com/sharer/sharer.php?u=%s&amp;t=%s',
      encodeURIComponent(url), SMFormatHelper.roomName(room)
    );
  }

  static shareRoomLineUrl(room){
    const prefix = location.pathname.length && location.pathname[0] == "?" ? "&" : "?";
    const subject = SMFormatHelper.roomName(room);
    const campaign = "room-" + room.uid;
    const url = "https://" + location.host + Routes.space_room_path(room.space.username, room.uid) + sprintf("%sutm_campaign=%s&utm_source=%s&utm_medium=%s",
      prefix, campaign, "line", "share"
    );
    return sprintf("http://line.me/R/msg/text/?%s",
      encodeURIComponent(subject + " " + url),
    );
  }

  static isSpacemarketEmployee(user){
    return user.email.includes("@spacemarket.co.jp");
  }
}
export default SMAppHelper;



// WEBPACK FOOTER //
// ./app/javascript/components/helpers/SMAppHelper.js